import { Client, cacheExchange, fetchExchange, mapExchange } from '@urql/core'
import { toast } from 'vue-sonner'

const mapExchangeOptions = {
    onError({ response, graphQLErrors }, operation) {
        let title: string | null = null
        let description: any = null

        if (response.status === 404) {
            title = '404 Not Found'
            description = response.url
        }

        if (response.status === 503) {
            title = '503 Service Unavailable'
            description = response.url
        }

        if (graphQLErrors.length > 0) {
            const error = graphQLErrors[0]

            if (error.extensions.category === 'authorization') {
                title = '401 Unauthorized'
                description = error.message
            }

            if (error.message === 'Internal server error') {
                title = 'Internal Server Error'
                description = error.extensions.debugMessage
            }
        }

        if (title) {
            toast.error(title, {
                description,
                duration: 3600000,
            })
        }
    },
}

const fetchOptions = () => {
    const regex = RegExp('XSRF-TOKEN[^;]+').exec(document.cookie)
    const token = decodeURIComponent(regex ? regex.toString().replace(/^[^=]+./, '') : '')

    return {
        credentials: 'include',
        headers: {
            'X-XSRF-TOKEN': token,
        },
    }
}

export const defaultGraphQLClient = new Client({
    url: import.meta.env.VITE_APP_GRAPHQL_DEFAULT_HTTP,
    exchanges: [mapExchange(mapExchangeOptions), cacheExchange, fetchExchange],
    fetchOptions,
    requestPolicy: 'network-only',
})

export const cpanelGraphQLClient = new Client({
    url: import.meta.env.VITE_APP_GRAPHQL_CPANEL_HTTP,
    exchanges: [mapExchange(mapExchangeOptions), cacheExchange, fetchExchange],
    fetchOptions,
    requestPolicy: 'network-only',
})

export const kamailioGraphQLClient = new Client({
    url: import.meta.env.VITE_APP_GRAPHQL_KAMAILIO_HTTP,
    exchanges: [mapExchange(mapExchangeOptions), cacheExchange, fetchExchange],
    fetchOptions,
    requestPolicy: 'network-only',
})

export const pbxwareGraphQLClient = new Client({
    url: import.meta.env.VITE_APP_GRAPHQL_PBXWARE_HTTP,
    exchanges: [mapExchange(mapExchangeOptions), cacheExchange, fetchExchange],
    fetchOptions,
    requestPolicy: 'network-only',
})

export const smsGlobalGraphQLClient = new Client({
    url: import.meta.env.VITE_APP_GRAPHQL_SMS_GLOBAL_HTTP,
    exchanges: [mapExchange(mapExchangeOptions), cacheExchange, fetchExchange],
    fetchOptions,
    requestPolicy: 'network-only',
})

export const vocusNBNGraphQLClient = new Client({
    url: import.meta.env.VITE_APP_GRAPHQL_VOCUS_NBN_HTTP,
    exchanges: [mapExchange(mapExchangeOptions), cacheExchange, fetchExchange],
    fetchOptions,
    requestPolicy: 'network-only',
})
